export const getDefaultInfinitePageParam = (page = 0, itemCount = 20) => ({
  page,
  itemCount,
});
